<template>
  <div>
    <div class="d-flex border">
      <!-- 树形结构 -->
      <div class="tree-container py-1" style="width: 166px;">
        <el-tree :data="treeList" :props="treeProps" highlight-current @node-click="handleNodeClick" />
      </div>
      <div class="transfet-container ml-auto">
        <el-transfer
          v-model="transferVal"
          style="text-align: left; display: inline-block"
          filterable
          :data="leftTransData"
          :filter-placeholder="placeholder"
          :titles="[$t('待选用户'), $t('已选用户')]"
          :format="{
            noChecked: '${total}',
            hasChecked: '${checked}/${total}'
          }"
          @right-check-change="selectNodeRight"
          @change="selectChangeRight"
        >
          <span slot-scope="{ option }">{{ option.label }} - {{ option.account }}</span>
        </el-transfer>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/lang';

export default {
  name: 'TransferTree',
  props: {
    // 树状展示数据
    treeList: {
      type: Array,
      default: () => { []; }
    },
    // 配置树状选项
    treeProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        };
      }
    },
    // 搜索框占位文本
    placeholder: {
      type: String,
      default: i18n.t('请输入')
    },
    // 搜索框大小
    size: {
      type: String,
      default: 'small'
    },
    // 左侧穿梭框数据源
    leftTransData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 左侧穿梭框表格列配置
    leftTableColumn: {
      type: Array,
      default() {
        return [];
      }
    },
    // 右侧穿梭框数据源
    rightTransData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 右侧穿梭框表格列配置
    rightTableColumn: {
      type: Array,
      default() {
        return [
          {
            type: 'checkbox',
            width: 40
          },
          {
            field: 'name',
            title: i18n.t('用户名称'),
            width: 150
          }
        ];
      }
    },
    // 右侧穿梭框移除数据
    removeRightData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      keyword: '',
      value: [],
      transferVal: [],
      renderFunc(h, option) {
        return <span>{ option.key } - { option.label }</span>;
      }
    };
  },
  watch: {
    removeRightData: {
      handler(val) {
        if (val && val.length > 0 && this.transferVal && this.transferVal.length > 0) {
          this.transferVal = this.transferVal.map(item => {
            val.includes(item) ? item = "" : "";
            return item;
          }).filter(Boolean);
        }
      }
    }
  },
  methods: {
    // 右侧列表元素改变
    selectChangeRight(val, key) {
      this.value4 = val;
      if (key === 'right') {
        this.$emit('selectNodeRight', val);
      }
    },
    // 右侧元素选中或取消
    selectNodeRight(value, key) {
      this.$emit('selectNodeRight', value);
    },
    // 点击节点时的回调
    handleNodeClick(item) {
      this.$emit('handleNodeClick', item);
    },
    // 获取输入框内容
    getInput() {
      this.$emit('getInput', this.keyword);
    },
    // 搜索输入框条件
    search() {
      this.$emit('search', this.keyword);
    },
    // 清空input
    clearInput() {
      this.$emit('clearInput');
    },
    // 点击左侧表格当前单元格
    cellLeftClick() {
      this.$emit('cellLeftClick');
    },
    // 点击右侧表格当前单元格
    cellRightClick() {
      this.$emit('cellRightClick');
    },
    // 点击左侧按钮添加到右侧
    pushToRight() {
      const select = this.$refs.leftTable.getCheckboxRecords();
      this.$emit('pushToRight', select);
      this.$refs.leftTable.removeCheckboxRow();
      this.$refs.leftTable.clearCheckboxRow();
    },
    // 点击右侧按钮添加到左侧
    delFromRight() {
      const select = this.$refs.rightTable.getCheckboxRecords();
      this.$emit('delFromRight', select);
      this.$refs.rightTable.removeCheckboxRow();
      this.$refs.rightTable.clearCheckboxRow();
    },
    // 获取已经选中的
    getSelectedVal() {
      const select = this.$refs.rightTable.getCheckboxRecords();
      this.$emit('getSelectedVal', select);
    }
  }
};
</script>

<style scoped>
  .el-transfer-panel{
    width: 270px;
  }
  .el-transfer-panel__list.is-filterable{
    width: 270px;
  }
  .el-transfer-panel__filter.el-input.el-input--small.el-input--prefix{
    width: 240px;
  }
  .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{
    font-size: 14px;
  }
</style>
